import * as _ from "lodash";
import { applyPath } from "../helpers/PathHelpers";
import { appStartBG } from "./SpecialData";
import { getDimenions } from "./ThemeHelpers";
export var breakpoints = {
    smallMobile: { width: 320 },
    mobile: { width: 375 },
    largeMobile: { width: 414 },
    tablet: { width: 768 },
    desktop: { width: 1280 },
    wide: { width: 1600 },
    ultraWide: { width: 1920 },
    extremlyWide: { width: 2560 },
};
export var defaultTheme = {
    content: {
        width: 0,
        height: 0,
    },
    checkbox: {
        notAnimated: false,
        animatedIcon: {
            url: "./images/lottiIcons/checkbox.json",
            behaviour: "PlayOnClickToggleDirection",
            padding: "1px 3px 3px 2px",
        },
        notAnimatedIcon: {
            selected: {
                name: "check square",
            },
            notSelected: {
                name: "square",
            },
        },
    },
    radioButton: {
        notAnimated: false,
        animatedIcon: {
            speed: 4,
            url: "./images/lottiIcons/radiobutton.json",
            behaviour: "PlayOnClickToggleDirection",
            padding: "2px 3px 3px 2px",
        },
        notAnimatedIcon: {
            selected: {
                name: "check circle",
            },
            notSelected: {
                name: "circle",
            },
        },
    },
    sidebars: {
        default: {
            minWidth: "200px",
            maxWidth: "320px",
        },
        padding: {
            left: 5,
            right: 10,
            top: 10,
            bottom: 10,
        },
    },
    /* global */
    backgroundColor: "#fff",
    color: "#000",
    padding: 0,
    browser: "unknown",
    mobileButtonBar: {
        buttonKind: "tertiary",
    },
    body: {
        backgroundColor: "#fff",
        color: "#000",
    },
    posts: {
        postTypeColoredButton: true,
        leftImageStyle: "thumbnails",
    },
    appStart: {
        backgroundUrl: appStartBG,
        boxShadow: "0px 4px 4px 0.5px rgba(58,62,63,0.5)",
        color: "#fff",
        progressColor: "@accent",
        progressBoxShadow: "1px 1px 5px 0px rgba(0,0,0,0.75)",
    },
    textFields: {
        normal: {
            height: 36,
            padding: "0.5em 10px",
            fontSize: "1em",
            fontWeight: 400,
        },
        small: {
            height: 24,
            padding: "0.5em 10px",
            fontSize: "0.8em",
            fontWeight: 400,
        },
        large: {
            height: 45,
            padding: "0.5em 10px",
            fontSize: "1.1em",
            fontWeight: 400,
        },
    },
    progressbarsHeights: {
        default: {
            height: "40px",
            iconSize: "18px",
        },
        thin: {
            height: "16px",
            iconSize: "14px",
        },
        thick: {
            height: "50px",
            iconSize: "50px",
        },
    },
    segmentSchemes: {
        default: {
            backgroundColor: "@veryLightGrey",
            color: "@darkGrey",
            padding: 10,
            borderRadius: 0,
        },
        accent: {
            color: "@accent",
            backgroundColor: "#ffcccc",
            padding: 20,
            borderRadius: 0,
        },
        info: {
            color: "@accentBlue",
            backgroundColor: "#c7e4ff",
            padding: 20,
            borderRadius: 0,
        },
        blank: {
            color: "#000000",
            backgroundColor: "@mainBackground",
            padding: "10px",
            borderRadius: 0,
        },
    },
    progressbarsSchemes: {
        default: {
            backgroundColor: "#cfcfcf",
            barColor: "#aaaaaa",
            labelColor: "#21242c",
            valueColor: "#21242c",
        },
        accent: {
            backgroundColor: "fade('@accent', 50%)",
            barColor: "@accent",
            labelColor: "#FFF",
            valueColor: "#FFF",
        },
        light: {
            backgroundColor: "@veryLightGrey",
            barColor: "@lightGrey",
            labelColor: "@darkGrey",
            valueColor: "@darkGrey",
        },
        minimal: {
            backgroundColor: "lighten('backgroundColor', 94%)",
            barColor: "lighten('backgroundColor', 88%)",
            labelColor: "lighten('color', 80%)",
            valueColor: "lighten('color', 80%)",
        },
    },
    donut: {
        rounded: false,
        shadowed: false,
    },
    /* sizes */
    iconSize: 18,
    iconMarginTop: 4,
    flagSize: 44,
    flagMarginTop: 4,
    fontSize: 14,
    fontSizeMenu: 14,
    fontSizeMenuMobile: 13,
    fontWeights: {
        light: 200,
        default: 400,
        heavy: 600,
        veryheavy: 900,
    },
    fontSizes: {
        default: 14,
        h1: 30,
        h2: 24,
        h3: 18,
    },
    headerHeight: 60,
    mobileGap: 55,
    applicationLogo: "https://cdn.imaginarity.com/public/images/imgLogo.svg",
    header: {
        padding: "0px 0px 2px 10px",
        //logoURL: "https://files.porsche.com/filestore/image/multimedia/none/875d5e3d-6763-47fe-bc52-809142d53274/svg/9bee0427-35f0-11ea-80c6-005056bbdc38/porsche-svg.svg"
        logoURL: "https://cdn.imaginarity.com/public/images/imgLogo.svg",
        //logoURL: "https://cdn.imaginarity.com/public/thepage/logo.png",
    },
    fontFamily: "Roboto, Arial, 'Courier New', Courier, monospace",
    colors: {
        //DEFAULT COLORS
        // accent: "#950014", // PAG
        accent: "#1e70bf",
        lightGrey: "#A5A5A5",
        middleLightGrey: "#CCCCCC",
        veryLightGrey: "#F7F6F6",
        darkGrey: "#3C3B3F",
        darkerGrey: "#2E2D30",
        mainBackground: "#FFFFFF",
        active: "fade('@accent', 100%)",
        inactive: "fade('@lightGrey', 30%)",
        hoverColor: "#d5001c",
        // ADDITIONAL COLORS
        mainForeground: "@darkGrey",
        mainBorderColor: "@middleLightGrey",
        accentBlue: "#004B93",
        accentLightBlue: "#5391C4",
        accentTurquoise: "#017379",
        accentGreen: "#019300",
        accentOrange: "#D88711",
        accentYellow: "#939100",
        accentRed: "#950014",
        accentPink: "#700043",
        accentPurple: "#3C007E",
        accentLightPurple: "#6610c2",
        accentBlack: "#000000",
        alertInfoSuccessTitle: "fade('@accentGreen', 70%)",
        alertInfoSuccess: "#CCE9CC",
        alertInfoErrorTitle: "fade('@accentRed', 70%)",
        alertInfoError: "#E5C8CC",
        alertInfoInformationTitle: "fade('@accentBlue', 70%)",
        alertInfoInformation: "#CCDBE9",
        alertInfoWarningTitle: "fade('@accentYellow', 70%)",
        alertInfoWarning: "#E9E9CC",
        formInputErrorBackground: "fade('@accent', 10%)",
        formInputErrorBorder: "@accent",
        formInputActiveBackground: "@veryLightGrey",
        formInputActiveBorder: "@darkGrey",
        formInpuDefaultBackground: "@mainBackground",
        formInputDefaultBorder: "@middleLightGrey",
    },
    headerArea: {
        backgroundColor: "@mainBackground",
        color: "@darkGrey",
        padding: 0,
    },
    badge: {
        backgroundColor: "@accent",
        color: "@veryLightGrey",
        padding: 0,
    },
    leftArea: {
        backgroundColor: "@darkGrey",
        color: "@veryLightGrey",
        padding: "0px 5px 0px 5px",
    },
    mainArea: {
        backgroundColor: "@mainBackground",
        color: "@darkGrey",
        padding: "0px 5% 0px 5%",
        // padding: "0px 5.56% 0px 5.56%",
    },
    rightArea: {
        backgroundColor: "@veryLightGrey",
        color: "@darkGrey",
        padding: "0px 5px 0px 5px",
    },
    emptyAvatarImageUrl: "https://cdn.imaginarity.com/public/images/noAvatar.svg",
    emptyImageUrl: "https://cdn.imaginarity.com/public/images/PAG_X.svg",
    emptyVideoThumbnail: "https://cdn.imaginarity.com/public/images/videoth.jpg",
    missingPreviewImageLink: "https://cdn.imaginarity.com/public/tube/nopreviewimage.svg",
    missingAudioSvg: "https://cdn.imaginarity.com/public/ppe/ppe_noAudio.svg",
    missingImageSvg: "https://cdn.imaginarity.com/public/ppe/ppe_noImage.svg",
    missingVideoSvg: "https://cdn.imaginarity.com/public/ppe/ppe_noVideo.svg",
    missingMediaSvg: "https://cdn.imaginarity.com/public/ppe/ppe_noMedia.svg",
    dropZoneSvg: "https://cdn.imaginarity.com/public/images/filedropzone.svg",
    //SCROLLBAR
    scrollbarWidth: 4,
    scrollbarHeight: 8,
    scrollbarRadius: 2,
    scrollbarTrack: "@inactive",
    scrollbarThumb: "@active",
    // TOOLTIP
    tooltipRadius: 0,
    tooltipAlignment: "center",
    tooltipPadding: 14,
    tooltipWidth: 300,
    tooltipBackground: "#FFF",
    tooltipColor: "#000",
    toolTipBoxShadow: "0px 0px 30px 1px rgba(0,0,0,0.3)",
    search: {
        borderColor: "@middleLightGrey",
        resultHoverColor: "@accent",
    },
    dimmer: {
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        animationDuration: 0.3,
        start: {
            name: "slide",
            from: "100vh",
            to: "0vh",
        },
        end: {
            name: "zoom",
            from: "1",
            to: "0",
        },
    },
    buttons: {
        contentAlignment: "center",
        primary: {
            backgroundColor: "@accent",
            color: "@veryLightGrey",
            hoverColor: {
                backgroundColor: "lighten('@accent', 70%)",
                color: "@veryLightGrey",
            },
            activeColor: {
                backgroundColor: "lighten('@accent', 70%)",
                color: "@veryLightGrey",
            },
            disabledColor: {
                backgroundColor: "lighten('@accent', 320%)",
                color: "lighten('@veryLightGrey', 60%)",
            },
        },
        secondary: {
            backgroundColor: "@darkGrey",
            color: "@veryLightGrey",
            hoverColor: {
                backgroundColor: "lighten('@darkGrey', 70%)",
                color: "@veryLightGrey",
            },
            activeColor: {
                backgroundColor: "lighten('@darkGrey', 70%)",
                color: "@veryLightGrey",
            },
            disabledColor: {
                backgroundColor: "lighten('@darkGrey', 320%)",
                color: "lighten('@veryLightGrey', 60%)",
            },
        },
        tertiary: {
            // backgroundColor: "@lightGrey",
            backgroundColor: "@veryLightGrey",
            color: "@darkGrey",
            hoverColor: {
                // backgroundColor: "lighten('@lightGrey', 70%)",
                backgroundColor: "@darkGrey",
                color: "@veryLightGrey",
            },
            activeColor: {
                // backgroundColor: "lighten('@lightGrey', 70%)",
                backgroundColor: "lighten('@veryLightGrey', 90%)",
                color: "@darkGrey",
            },
            disabledColor: {
                backgroundColor: "lighten('@lightGrey', 130%)",
                color: "lighten('@darkGrey', 220%)",
            },
        },
        blank: {
            backgroundColor: "transparent",
            color: "@lightGrey",
            iconColor: "@lightGrey",
            hoverColor: {
                backgroundColor: "transparent",
                color: "@darkGrey",
                iconColor: "@darkGrey",
            },
            activeColor: {
                backgroundColor: "transparent",
                color: "@darkGrey",
                iconColor: "@darkGrey",
            },
            disabledColor: {
                backgroundColor: "transparent",
                color: "@darkGrey",
                iconColor: "@darkGrey",
            },
        },
    },
    tooltips: {
        primary: {
            color: "@accent",
            backgroundColor: "@mainBackground",
        },
        secondary: {
            color: "@darkGrey",
            backgroundColor: "@veryLightGrey",
        },
        tertiary: {
            color: "@darkGrey",
            backgroundColor: "@middleLightGrey",
        },
        blank: {
            color: "@darkGrey",
            backgroundColor: "@mainBackground",
        },
    },
    table: {
        cell: {
            paddingBottomTop: 3,
            paddingLeftRight: 5,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "lighten('@veryLightGrey', 90%)",
        },
        head: {
            backgroundColor: "lighten('@veryLightGrey', 99%)",
        },
        foot: {
            backgroundColor: "lighten('@veryLightGrey', 99%)",
        },
    },
    form: {
        inputs: {
            error: {
                themeViewStates: {
                    active: {
                        borderColor: "@formInputErrorBorder",
                        backgroundColor: "@formInputErrorBackground",
                        color: "@accentRed",
                        borderless: false,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@formInputErrorBorder",
                        backgroundColor: "@formInputErrorBackground",
                        color: "@accentRed",
                        borderless: false,
                        bottomBorder: true,
                    },
                },
            },
            default: {
                themeViewStates: {
                    active: {
                        borderColor: "@darkGrey",
                        backgroundColor: "@veryLightGrey",
                        color: "@darkGrey",
                        borderless: false,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@formInputDefaultBorder",
                        backgroundColor: "@formInpuDefaultBackground",
                        color: "@darkGrey",
                        borderless: false,
                        bottomBorder: true,
                    },
                },
            },
            defaultTransparent: {
                themeViewStates: {
                    active: {
                        borderColor: "@darkGrey",
                        backgroundColor: "fade('@accentBlue', 10%)",
                        color: "color",
                        borderless: true,
                        bottomBorder: false,
                    },
                    inactive: {
                        borderColor: "@middleLightGrey",
                        backgroundColor: "lighten('backgroundColor', 97%)",
                        color: "color",
                        borderless: true,
                        bottomBorder: false,
                    },
                },
            },
            transparentFull: {
                themeViewStates: {
                    active: {
                        borderColor: "transparent",
                        backgroundColor: "transparent",
                        color: "color",
                        borderless: true,
                        bottomBorder: false,
                    },
                    inactive: {
                        borderColor: "transparent",
                        backgroundColor: "transparent",
                        color: "color",
                        borderless: true,
                        bottomBorder: false,
                    },
                },
            },
            borderless: {
                themeViewStates: {
                    active: {
                        borderColor: "transparent",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: false,
                    },
                    inactive: {
                        borderColor: "transparent",
                        backgroundColor: "transparent",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: false,
                    },
                },
            },
            borderlessDark: {
                themeViewStates: {
                    active: {
                        borderColor: "@lightGrey",
                        backgroundColor: "transparent",
                        color: "@veryLlightGrey",
                        borderless: true,
                        bottomBorder: false,
                    },
                    inactive: {
                        borderColor: "@formInputDefaultBorder",
                        backgroundColor: "transparent",
                        color: "@lightGrey",
                        borderless: true,
                        bottomBorder: false,
                    },
                },
            },
            borderlessError: {
                themeViewStates: {
                    active: {
                        borderColor: "@formInputErrorBorder",
                        backgroundColor: "@formInputErrorBackground",
                        color: "@accentRed",
                        borderless: true,
                        bottomBorder: false,
                    },
                    inactive: {
                        borderColor: "@formInputErrorBorder",
                        backgroundColor: "@formInputErrorBackground",
                        color: "@accentRed",
                        borderless: true,
                        bottomBorder: false,
                    },
                },
            },
            success: {
                themeViewStates: {
                    active: {
                        borderColor: "lighten('@accentGreen', 50%)",
                        backgroundColor: "@alertInfoSuccessTitle",
                        color: "@accentGreen",
                        borderless: false,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@accentGreen",
                        backgroundColor: "@alertInfoSuccessTitle",
                        color: "@accentGreen",
                        borderless: false,
                        bottomBorder: true,
                    },
                },
            },
            bottomLine: {
                themeViewStates: {
                    active: {
                        borderColor: "@darkGrey",
                        backgroundColor: "@veryLightGrey",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@formInputDefaultBorder",
                        backgroundColor: "@formInpuDefaultBackground",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: true,
                    },
                },
            },
            bottomLineError: {
                themeViewStates: {
                    active: {
                        borderColor: "@formInputErrorBorder",
                        backgroundColor: "@formInputErrorBackground",
                        color: "@accentRed",
                        borderless: true,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@formInputErrorBorder",
                        backgroundColor: "@formInputErrorBackground",
                        color: "@accentRed",
                        borderless: true,
                        bottomBorder: true,
                    },
                },
            },
            bottomLineSuccess: {
                themeViewStates: {
                    active: {
                        borderColor: "@accentGreen",
                        backgroundColor: "@alertInfoSuccessTitle",
                        color: "@accentGreen",
                        borderless: true,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@accentGreen",
                        backgroundColor: "@alertInfoSuccessTitle",
                        color: "@accentGreen",
                        borderless: true,
                        bottomBorder: true,
                    },
                },
            },
            transparent: {
                themeViewStates: {
                    active: {
                        borderColor: "@darkGrey",
                        backgroundColor: "fade('@darkerGrey', 5%)",
                        color: "@lightGrey",
                        borderless: true,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@middleLightGrey",
                        backgroundColor: "transparent",
                        color: "@darkerGrey",
                        borderless: true,
                        bottomBorder: true,
                    },
                },
            },
            cancelButtonStyle: {
                themeViewStates: {
                    active: {
                        borderColor: "@middleLightGrey",
                        backgroundColor: "lighten('@veryLightGrey', 95%)",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@veryLightGrey",
                        backgroundColor: "@veryLightGrey",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: true,
                    },
                },
            },
            tableInputCell: {
                themeViewStates: {
                    active: {
                        borderColor: "@darkGrey",
                        backgroundColor: "lighten('@veryLightGrey', 95%)",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: false,
                    },
                    inactive: {
                        borderColor: "transparent",
                        backgroundColor: "transparent",
                        color: "@darkGrey",
                        borderless: true,
                        bottomBorder: false,
                    },
                },
            },
            darkMode: {
                themeViewStates: {
                    active: {
                        borderColor: "#000000",
                        backgroundColor: "@darkerGrey",
                        color: "@mainBackground",
                        borderless: true,
                        bottomBorder: true,
                    },
                    inactive: {
                        borderColor: "@darkerGrey",
                        backgroundColor: "@darkerGrey",
                        color: "@mainBackground",
                        borderless: true,
                        bottomBorder: true,
                    },
                },
            },
        },
        entryPadding: "0px 10px 0px 10px",
        borderRadius: "0",
    },
    select: {
        borderColor: "@lightGrey",
        borderColorHovered: "@accent",
        focusColor: "@lightGrey",
        borderRadius: "0px",
        inputFieldBoxShadow: "none",
        hoverColor: "@lightGrey",
        optionFontColor: "#000",
        optionBackgroundHoverColor: "@accent",
        optionFontHoverColor: "@mainBackground",
        optionBackgroundColor: "@mainBackground",
    },
    alerts: {
        kinds: {
            error: {
                titleColor: "@alertInfoErrorTitle",
                color: "@alertInfoError",
                backgroundColor: "@alertInfoError",
            },
            information: {
                titleColor: "@alertInfoInformationTitle",
                color: "@alertInfoInformation",
                backgroundColor: "@alertInfoInformation",
            },
            success: {
                titleColor: "@alertInfoSuccessTitle",
                color: "@alertInfoSuccess",
                backgroundColor: "@alertInfoSuccess",
            },
            warning: {
                titleColor: "@alertInfoWarningTitle",
                color: "@alertInfoWarning",
                backgroundColor: "@alertInfoWarning",
            },
        },
        borderRadius: "0",
        start: {
            name: "slide",
            from: "250%",
            to: "0%",
        },
        end: {
            name: "slide",
            from: "0%",
            to: "250%",
        },
        animationDuration: 0.3,
    },
    menus: {
        primary_menu: {
            contentAlignment: "left",
            backgroundColor: "#3f3f3f",
            color: "#ffffff",
            hoverColor: {
                backgroundColor: "@veryLightGrey",
                color: "#000000",
            },
            activeColor: {
                backgroundColor: "#6f6f6f",
                color: "#ffffff",
            },
            disabledColor: {
                backgroundColor: "#3f3f3f7f",
                color: "#ffffff7f",
            },
        },
        secondary_menu: {
            contentAlignment: "left",
            backgroundColor: "#3f3f3f",
            color: "#ffffff",
            hoverColor: {
                backgroundColor: "@veryLightGrey",
                color: "#000000",
            },
            activeColor: {
                backgroundColor: "#6f6f6f",
                color: "#ffffff",
            },
            disabledColor: {
                backgroundColor: "#3f3f3f7f",
                color: "#ffffff7f",
            },
        },
        tertiary_menu: {
            contentAlignment: "left",
            backgroundColor: "@mainBackground",
            color: "@mainForeground",
            hoverColor: {
                backgroundColor: "@veryLightGrey",
                color: "@accent",
            },
            activeColor: {
                backgroundColor: "@mainForeground",
                color: "@mainBackground",
            },
            disabledColor: {
                backgroundColor: "@mainBackground",
                color: "lighten('@mainForeground', 300%)",
            },
        },
    },
    components: {
        transparentButton: {
            baseDefinition: function (t) { return t.buttons.primary; },
            overrides: {
                backgroundColor: "transparent",
                color: "color",
                hoverColor: {
                    backgroundColor: "lighten('backgroundColor', 90%)",
                    color: "color",
                },
                activeColor: {
                    backgroundColor: "lighten('backgroundColor', 80%)",
                    color: "color",
                },
                disabledColor: {
                    backgroundColor: "transparent",
                    color: "color",
                }
            },
        },
        transparentButtonDark: {
            baseDefinition: function (t) { return t.buttons.primary; },
            overrides: {
                backgroundColor: "transparent",
                color: "@mainBackground",
                hoverColor: {
                    backgroundColor: "rgba(0,0,0,0.1)",
                    color: "@mainBackground",
                },
                activeColor: {
                    backgroundColor: "rgba(0,0,0,0.2)",
                    color: "@mainBackground",
                },
                disabledColor: {
                    backgroundColor: "transparent",
                    color: "rgba(255,255,255,0.3)",
                },
            },
        },
        editButton: {
            baseDefinition: function (t) { return t.buttons.tertiary; },
            overrides: {
                backgroundColor: "@accentBlue",
                color: "@veryLightGrey",
                hoverColor: {
                    backgroundColor: "lighten('@accentBlue', 115%)",
                    color: "@veryLightGrey",
                },
            },
        },
        editorButton: {
            baseDefinition: function (t) { return t.buttons.tertiary; },
            overrides: {
                backgroundColor: "fade('@darkGrey', 0%)",
                color: "@darkGrey",
                hoverColor: {
                    backgroundColor: "fade('@darkGrey', 10%)",
                    color: "@darkGrey",
                },
                activeColor: {
                    backgroundColor: "fade('@darkGrey', 15%)",
                    color: "@accentBlack",
                },
                disabledColor: {
                    backgroundColor: "fade('@darkGrey', 0%)",
                    color: "@lightGrey",
                },
            },
        },
        sendButton: {
            baseDefinition: function (t) { return t.buttons.tertiary; },
            overrides: {
                backgroundColor: "@accentGreen",
                color: "@veryLightGrey",
                hoverColor: {
                    backgroundColor: "lighten('@accentGreen', 115%)",
                    color: "@veryLightGrey",
                },
            },
        },
        cancelButton: {
            baseDefinition: function (t) { return t.buttons.tertiary; },
            overrides: {
                backgroundColor: "@veryLightGrey",
                hoverColor: {
                    backgroundColor: "lighten('@veryLightGrey', 95%)",
                    color: "@darkGrey",
                },
                disabledColor: {
                    backgroundColor: "fade('@veryLightGrey', 30%)",
                    color: "fade('@lightGrey', 70%)",
                }
            },
        },
        labelButton: {
            baseDefinition: function (t) { return t.buttons.tertiary; },
            overrides: {
                backgroundColor: "@veryLightGrey",
                hoverColor: {
                    backgroundColor: "@veryLightGrey",
                    color: "@darkGrey",
                },
                disabledColor: {
                    backgroundColor: "@veryLightGrey",
                    color: "@darkGrey",
                },
            },
        },
        tabButton: {
            baseDefinition: function (t) { return t.buttons.secondary; },
            overrides: {
                activeColor: {
                    backgroundColor: "@accent",
                    color: "@veryLightGrey",
                },
                hoverColor: {
                    backgroundColor: "lighten('@darkGrey', 80%)",
                    color: "@lightGrey",
                },
            },
        },
        tabButtonTertiary: {
            baseDefinition: function (t) { return t.buttons.tertiary; },
            overrides: {
                activeColor: {
                    backgroundColor: "@accent",
                    color: "@veryLightGrey",
                },
                hoverColor: {
                    backgroundColor: "lighten('@darkGrey', 80%)",
                    color: "@lightGrey",
                },
            },
        },
        fullTransparentButton: {
            baseDefinition: function (t) { return t.buttons.primary; },
            overrides: {
                backgroundColor: "transparent",
                color: "@lightGrey",
                hoverColor: {
                    backgroundColor: "transparent",
                    color: "@darkGrey",
                },
                disabledColor: {
                    backgroundColor: "transparent",
                    color: "@darkGrey",
                },
            },
        },
        halfTransparentButton: {
            baseDefinition: function (t) { return t.buttons.primary; },
            overrides: {
                backgroundColor: "#ffffff61",
                color: "@darkGrey",
                hoverColor: {
                    backgroundColor: "#ffffff96",
                    color: "@darkGrey",
                },
            },
        },
        halfTransparentButtonDark: {
            baseDefinition: function (t) { return t.buttons.primary; },
            overrides: {
                //backgroundColor: "rgba(0,0,0,0.3)",
                backgroundColor: "rgba(255,255,255,0.05)",
                color: "@mainBackground",
                hoverColor: {
                    backgroundColor: "@accent",
                    color: "@mainBackground",
                },
            },
        },
        /*        appMenu: {
                        colors: {
                            baseDefinition: t => t.colors,
                            overrides: {
                                accent: "#30FF60",
                            },
                        },
                        fontFamily: {
                            baseDefinition: t => t.fontFamily,
                            overrides: "Arial",
                        }
                    }
            */
    },
    contentInteraction: {
        tooltipKind: "textline",
        actionButtons: {
            kind: "secondary",
            size: "default",
            floated: "left",
        },
        topActionButtons: {
            kind: "primary",
            size: "default",
            floated: "left",
        },
        inSideNavigationButtons: {
            kind: "transparentButton",
            size: "default",
            floated: "right",
        },
        navigationButtons: {
            kind: "secondary",
            size: "default",
            floated: "right",
        },
        moreButtons: {
            kind: "transparentButton",
            size: "default",
            floated: "right",
        },
    },
    applicationTheming: {},
    editor: {
        lineHeight: 1.4285,
        height: "100%",
        padding: "12px 15px",
        fontSize: "14px",
        listPaddingLeft: "1em",
        listFontSize: "14px",
        listFontWeight: "none",
        toolbarColor: {
            color: "@accent",
            backgroundColor: "@veryLightGrey",
        },
        toolbarBorder: "1px solid #A5A5A5",
        toolbarPadding: "1px",
        toolbarFontFamily: "Roboto, Arial, Courier, monospace",
        toolbarButton: {
            color: {
                color: "@accent",
                backgroundColor: "@veryLightGrey",
                iconColor: "@accent",
            },
            border: "none",
            padding: "3px 5px",
            height: "24px",
            width: "28px",
        },
        containerColor: {
            backgroundColor: "#FFF",
            color: "@darkGrey",
        },
        containerBorder: "1px solid #A5A5A5",
        containerFontFamily: "Roboto, Arial, Courier, monospace",
        h1: {
            fontSize: "2em",
            lineHeight: 1.42,
        },
        h2: {
            fontSize: "1.5em",
            lineHeight: 1.42,
        },
        h3: {
            fontSize: "1em",
            lineHeight: 1.42,
        },
        h4: {
            fontSize: "0.8em",
            lineHeight: 1.42,
        },
        h5: {
            fontSize: "0.5em",
            lineHeight: 1.42,
        },
        h6: {
            fontSize: "0.2em",
            lineHeight: 1.42,
        },
        p: {
            lineHeight: 1.4825,
            margin: "0 0 1em",
        },
    },
    loaderInitialDelay: 0,
};
export function calculateComponentDefinition(p, def) {
    var origin = _.clone(def.baseDefinition(p.theme));
    _.forEach(def.overrides, function (val, key) { return (origin[key] = val); });
    return origin;
}
export function belowBreakpointOrEqual(p, breakpoint) {
    var keys = Object.keys(breakpoints);
    keys.unshift("verySmall");
    var i1 = _.findIndex(keys, function (k) { return k === p.theme.currentScreenBreakPoint; });
    var i2 = _.findIndex(keys, function (k) { return k === breakpoint; });
    return i1 <= i2;
}
export function belowBreakpoint(p, breakpoint) {
    var keys = Object.keys(breakpoints);
    keys.unshift("verySmall");
    var i1 = _.findIndex(keys, function (k) { return k === p.theme.currentScreenBreakPoint; });
    var i2 = _.findIndex(keys, function (k) { return k === breakpoint; });
    return i1 < i2;
}
export function aboveBreakpointOrEqual(p, breakpoint) {
    var keys = Object.keys(breakpoints);
    keys.unshift("verySmall");
    var i1 = _.findIndex(keys, function (k) { return k === p.theme.currentScreenBreakPoint; });
    var i2 = _.findIndex(keys, function (k) { return k === breakpoint; });
    return i1 >= i2;
}
export function aboveBreakpoint(p, breakpoint) {
    var keys = Object.keys(breakpoints);
    keys.unshift("verySmall");
    var i1 = _.findIndex(keys, function (k) { return k === p.theme.currentScreenBreakPoint; });
    var i2 = _.findIndex(keys, function (k) { return k === breakpoint; });
    return i1 > i2;
}
export function getThemeEntry(p, f) {
    var entry = applyPath(p.theme, f);
    return entry;
}
export var appendPx = function (val) { return (typeof val === "string" ? val : "".concat(val, "px")); };
export function getPaddingOrAlt(p, f, altValue) {
    var padding = getThemeEntry(p, f);
    if (padding)
        return appendPx(padding);
    return appendPx(altValue);
}
export function getDimensionOrAlt(p, f, altValue) {
    var dimension = getThemeEntry(p, f);
    if (dimension)
        return appendPx(dimension);
    return appendPx(altValue);
}
export function calcHeightMinusPadding(height, padding) {
    if (typeof padding === "string") {
        var split = getDimenions(padding);
        return flattenCalc("calc(".concat(appendPx(height), " - ").concat(split[0], " - ").concat(split[2], ")"));
    }
    return flattenCalc("calc(".concat(appendPx(height), " - ").concat(2 * padding, "px)"));
}
export function calcWidthMinusPadding(width, padding) {
    if (typeof padding === "string") {
        var split = getDimenions(padding);
        return flattenCalc("calc(".concat(appendPx(width), " - ").concat(split[1], " - ").concat(split[3], ")"));
    }
    return flattenCalc("calc(".concat(appendPx(width), " - ").concat(2 * padding, "px)"));
}
export function getSizeAsNumber(size) {
    var sizeRegex = /(\d*(\.\d*)?)(.*)$/gm;
    if (typeof size === "number")
        return size;
    else {
        var res = sizeRegex.exec(size);
        if (res)
            return parseFloat(res[1]);
    }
    return 0;
}
export function scaleSize(size, factor) {
    var sizeRegex = /(\d*(\.\d*)?)(.*)$/gm;
    if (typeof size === "number")
        return size * factor;
    var res = sizeRegex.exec(size);
    if (res)
        return "".concat(parseFloat(res[1]) * factor).concat(res[3]);
    return 0;
}
export function scalePadding(padding, factor) {
    if (typeof padding === "string") {
        var split = padding.split(" ");
        if (split.length === 1)
            return "".concat(scaleSize(split[0], factor));
        if (split.length === 2)
            return "".concat(scaleSize(split[0], factor), " ").concat(scaleSize(split[1], factor));
        else
            return "".concat(scaleSize(split[0], factor), " ").concat(scaleSize(split[1], factor), " ").concat(scaleSize(split[2], factor), " ").concat(scaleSize(split[3], factor));
    }
    return padding * factor;
}
export function explodePadding(padding) {
    if (typeof padding === "string") {
        var split = padding.split(" ");
        if (split.length === 1)
            return {
                top: split[0],
                right: split[0],
                bottom: split[0],
                left: split[0],
            };
        if (split.length === 2)
            return {
                top: split[0],
                right: split[1],
                bottom: split[0],
                left: split[1],
            };
        else
            return {
                top: split[0],
                right: split[1],
                bottom: split[2],
                left: split[3],
            };
    }
    return {
        top: "".concat(padding, "px"),
        right: "".concat(padding, "px"),
        bottom: "".concat(padding, "px"),
        left: "".concat(padding, "px"),
    };
}
export function flattenCalc(text) {
    if (text.startsWith("calc(")) {
        var t = text.substring(4);
        return "calc".concat(t.replace("calc", ""));
    }
    return text;
}
export var getSidebarWidth = function (p) {
    var _a, _b;
    return ((_b = (p.theme.sidebars.forBreakPoint
        ? p.theme.sidebars.forBreakPoint[(_a = p.theme.currentScreenBreakPoint) !== null && _a !== void 0 ? _a : ""]
        : undefined)) !== null && _b !== void 0 ? _b : p.theme.sidebars.default);
};
export function getSidebarMinWidth(p) {
    return getSidebarWidth(p).minWidth;
}
export function getSidebarMaxWidth(p) {
    return getSidebarWidth(p).maxWidth;
}
//# sourceMappingURL=DefaultTheme.js.map